import React from 'react';
import Select from 'components/UI/V3/Forms/Select';
import styles from './MinNightsSection.module.scss';
import clsx from 'clsx';

interface MinNightsSectionProps {
    value: number;
    onChange: (value: number) => void;
    className?: string;
}

export const MinNightsSection: React.FC<MinNightsSectionProps> = ({ value, onChange, className }) => {
    // Generate options for min nights (1-30)
    const minNightsOptions = Array.from({ length: 30 }, (_, i) => ({
        value: i + 1,
        label: `${i + 1} night${i === 0 ? '' : 's'}`
    }));

    const handleOptionSelect = (optionValue: string) => {
        onChange(parseInt(optionValue, 10));
    };

    return (
        <div className={`${styles.container} ${className || ''}`}>
            <div className={styles.labelContainer}>
                <span className={styles.label}>Min Nights</span>
                <div className={styles.description}>Set the minimum number of nights required to make a booking.</div>
            </div>

            <Select
                className={clsx(styles.select, className)}
                value={value.toString()}
                options={minNightsOptions.map(option => ({
                    value: option.value.toString(),
                    label: option.label
                }))}
                onChange={handleOptionSelect}
            />
        </div>
    );
};
